import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { ClearTobaccoGaleraProductionReducer, GetTobaccoGaleraProductionReducer } from './reducers';
import { GetTobaccoGaleraProduction } from './thunks';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'tobaccoGaleraProduction',
  initialState,
  reducers: {
    ClearTobaccoGaleraProduction: ClearTobaccoGaleraProductionReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetTobaccoGaleraProduction, GetTobaccoGaleraProductionReducer);
  },
});

export default slice.reducer;
